import type {
    AmenityId} from "@@/shared/acquire/resources/resource-accommodation/amenities/amenity-id";
import {
    amenityIdFactory,
    amenityIdZodSchema,
} from "@@/shared/acquire/resources/resource-accommodation/amenities/amenity-id";
import { amenityTypeZodEnum } from "@@/shared/acquire/resources/resource-accommodation/amenities/amenity-type";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { iconNameZodString } from "@@/shared/icon-name";
import { providerIdZodSchema } from "@@/shared/providers/provider-id";
import {
    requiredTranslatableZodSchema,
    translatableZodSchema,
} from "@@/shared/translations/translation";
import { userIdZodSchema } from "@@/shared/users/user-id";
import type { Except } from "type-fest";
import { z } from "zod";

const amenityZodObject = z.object({
    _id: amenityIdZodSchema,
    _type: z.literal("AMENITY"),
    _createdAt: isoAndUnixZodSchema,
    _createdBy: userIdZodSchema,
    type: amenityTypeZodEnum,
    title: requiredTranslatableZodSchema,
    shortDescription: translatableZodSchema.optional(),
    description: translatableZodSchema.optional(),
    providerId: providerIdZodSchema.optional(),
    iconName: iconNameZodString.optional(),
});

type Amenity = z.infer<typeof amenityZodObject>;

type FactoryParams = Except<Amenity, "_id" | "_type" | "_createdAt"> & {
    _id?: AmenityId;
};
const amenityFactory = (params: FactoryParams): Amenity => {
    return {
        ...params,
        _id: params._id ?? amenityIdFactory(),
        _type: "AMENITY",
        _createdAt: nowIsoAndUnix(),
    };
};

export { amenityFactory, amenityZodObject };
export type { Amenity };
